import {firestore, getBasePath} from "../firebase";
import {mapSnapshot} from "../api";

export const FETCH_TEAM_INVITE = "FETCH_TEAM_INVITE";
export function fetchInvite(team, nonce){

    return {
        type: FETCH_TEAM_INVITE,
        payload: firestore
            .collection("teams/" + team + "/invites")
            .where("nonce", "==", nonce)
            .get()
            .then(res => mapSnapshot(res, "nonce"))
    }
}

export const FETCH_TEAM_INVITES = "FETCH_TEAM_INVITES";
export function fetchTeamInvites(){
    return {
        type: FETCH_TEAM_INVITES,
        payload: firestore
            .collection(getBasePath() + "/invites")
            .get()
            .then(res => mapSnapshot(res))
    }
}
export function fetchTeamInvitesIfNeeded(){
    return (dispatch, state) => {
        const {invites} = state();
        if(!invites.fetched && !invites.fetching){
            dispatch(fetchTeamInvites());
        }
    };
}

export const CREATE_TEAM_INVITE = "CREATE_TEAM_INVITE";
export function createInvite(data){
    return {
        type: CREATE_TEAM_INVITE,
        payload: firestore
            .collection(getBasePath() + "/invites")
            .add(data)
            .then(ref => ({[ref.id]: {...data, id: ref.id}}))
    }
}


export const DELETE_TEAM_INVITE = "DELETE_TEAM_INVITE";
export function deleteInvite(inviteId){
    return {
        type: DELETE_TEAM_INVITE,
        meta: {id: inviteId},
        payload: firestore
            .doc(getBasePath() + "/invites/" + inviteId)
            .delete()
    }
}



// WEBPACK FOOTER //
// ./src/actions/InviteActions.js